import React, { useState, Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  FormFlexWrapper,
  DropdownWrapper,
  FormGroup,
  FlexWrapper,
  Error,
  SelectCustomStyles,
  CommonLabel,
} from "@app/components/commonStyles";
import {
  Input,
  Password,
  Accordian,
  LoginLayout,
  Button,
  DeleteChildDialog,
  Radio,
  Toast,
  Overlay,
} from "@app/components";
import {
  gradesList,
  stateList,
  MonthList,
  yearsList,
  childPlayOptions,
  chatOptions,
  perferneceOptions,
  subjectOptions,
  subscriptionOptions,
  passwordPattern,
  emailPattern,
  getValuesOnly,
  useLocation,
  objArrayToArrayobjConvertor,
  validateFormData,
} from "@app/utils";
import { createUser, validateEmail } from "@app/services";
import { Container, ButtonContainer, SubBox } from "../sign-up.component";

export default function ChildCreateAccount() {
  const {
    handleSubmit,
    register,
    errors,
    control,
    watch,
    trigger,
    getValues,
    clearErrors,
  }: any = useForm({
    shouldUnregister: false,
    mode: "onChange",
  });
  const { navigate } = useLocation();
  const [childAccounts, updateChildAccounts]: any = React.useState([{}]);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [selectedId, setSeletedId] = useState<number>(0);
  const [buttonText, setButtontext] = useState<string>("Link Child Account");
  const [showDelete, setShowDetete] = useState<boolean>(false);
  const [deleteIndex, setDeleteIndex] = useState<number>(0);
  const [deleteText, setDeleteText] = useState<string>("Delete");
  const [inValidIndex, setInValidIndex] = useState<any>(-1);
  const [validIndexs, setValidIndexs] = useState<any[]>([]);
  const [showOverLay, setShowOverLay] = useState<boolean>(false);
  const [emailValidate, setEmailValidate] = useState<any[]>([
    {
      validate: false,
      valid: false,
      Eerror: false,
    },
  ]);
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });

  function addChildAccount() {
    const lastIndex: number = childAccounts.length - 1;
    setSeletedId(lastIndex + 1);
    updateChildAccounts([...childAccounts, {}]);
    setEmailValidate([
      ...emailValidate,
      {
        validate: false,
        valid: false,
        Eerror: false,
      },
    ]);
  }

  function onPasswordBlur(i: any) {
    if (getValues(`confirmPassword[${i}]`)) {
      trigger(`confirmPassword[${i}]`);
    }
  }

  function onEmailBlur(i: number) {
    const emailValue = getValues(`email[${i}]`);
    let temp_Arr = [...emailValidate];
    if (emailValue) {
      temp_Arr[i].validate = true;
      setEmailValidate(temp_Arr);
      let t_Arr = [...emailValidate];
      validateEmail({ email: emailValue })
        .then((response: any) => {
          if (response._responseStatus === 1) {
            t_Arr[i].validate = false;
            t_Arr[i].valid = true;
            t_Arr[i].Eerror = false;
            setEmailValidate(t_Arr);
          } else {
            t_Arr[i].validate = false;
            t_Arr[i].valid = false;
            t_Arr[i].Eerror = true;
            setEmailValidate(t_Arr);
          }
        })
        .catch((err: any) => {
          t_Arr[i].validate = false;
          t_Arr[i].valid = false;
          t_Arr[i].Eerror = false;
          setEmailValidate(t_Arr);
          console.log(err);
        });
    }
  }

  const removeArrEle = (arr: Array<any>, index: number) => {
    return arr.slice(0, index).concat(arr.slice(index + 1));
  };
  const deleteChild = (i: number) => {
    setDeleteIndex(i);
    setShowDetete(true);
  };

  function onChildDelete() {
    setDeleteText("Deleting...");
    setTimeout(() => {
      const updatedList = removeArrEle(childAccounts, deleteIndex);
      updateChildAccounts(updatedList);
      setDeleteText("Delete");
      setShowDetete(false);
    }, 500);
  }

  const onSubmit = (data: any) => {
    let childArray: any[] = objArrayToArrayobjConvertor(data);
    childArray = childArray.filter((child: any, index: number) => {
      return validIndexs.findIndex((valid) => valid === index) === -1;
    });
    getChildAccout(childArray);
  };

  let counter: number = 0;
  function getChildAccout(childArray: any[]) {
    if (childArray.length > counter) {
      childSignUp(childArray[counter], counter)
        .then((res: any) => {
          counter++;
          if (res && res._responseStatus === 1) {
            setTimeout(() => {
              getChildAccout(childArray);
            }, 500);
          }
        })
        .catch((err: any) => {
          console.log(err);
          setInValidIndex("");
          setButtontext("Link Child Account");
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: "Something went wrong, Please try again",
          });
          counter++;
        });
    } else {
      setButtontext("Link Child Account");
      localStorage.removeItem("parentData");
      setValidIndexs([]);
      setInValidIndex(-1);
      setShowOverLay(true);
      setTimeout(() => {
        setShowOverLay(false);
        navigate("/sign-in/parent");
      }, 5000);
    }
  }

  async function childSignUp(data: any, counter: number) {
    const validData: any = validateFormData(data);
    if (!validData && validData !== undefined) {
      setInValidIndex(counter);
      setSeletedId(counter);
      setIsActive(true);
      setShowToast(true);
      setToastMessage({
        type: "error",
        message: `Please fill all required detais.`,
      });
      setButtontext("Link Child Account");
      return;
    }
    setButtontext("Linking...");
    let parentData: any = localStorage.getItem("parentData");
    parentData = parentData ? JSON.parse(parentData) : null;
    const subjectValues: any = getValuesOnly(data.subject);
    const params: any = {};
    Object.assign(params, {
      userType: "student",
      homeAccountReg: 1,
      firstName: data.firstName,
      lastName: data.lastName,
      birthMonth: data.birthMonth.value,
      birthYear: data.birthYear.value,
      userGrade: data.grade.value,
      city: data.city,
      state: data.state.value,
      zip: data.zipCode,
      email: data.email,
      password: data.password,
      confirmPassword: data.confirmPassword,
      parentId: parentData.userId,
      sessionToken: parentData.sessionToken,
      childPlayOption: data.childPlayOption,
      childMayUse: data.chatOption,
      levelPreference: data.levelPreference,
      subject: subjectValues,
      subscriptionPlans: data.subscriptionOption,
      termsOfService: 1,
    });

    return await createUser(params)
      .then((response: any) => {
        if (response._responseStatus === 1) {
          const temp_validArray = validIndexs.concat(counter);
          setValidIndexs(temp_validArray);
          return response;
        } else {
          setInValidIndex(counter);
          setSeletedId(counter);
          setIsActive(true);
          setButtontext("Link Child Account");
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });
        }
      })
      .catch((err: any) => {
        setButtontext("Link Child Account");
        console.log(err, "ChildAccountError");
      });
  }

  function getTitle(i: number) {
    let title: string = "";
    const firstName = getValues(`firstName[${i}]`);
    const lastName = getValues(`lastName[${i}]`);
    if (firstName && lastName) {
      title = `${firstName} ${lastName}`;
    } else if (firstName && !lastName) {
      title = `${firstName} `;
    } else if (!firstName && lastName) {
      title = `${lastName} `;
    } else {
      title = `Child ${i + 1}`;
    }
    return title;
  }

  return (
    <LoginLayout path="" label="">
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        title="Link Child Failed"
        onClose={() => setShowToast(false)}
      />
      <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="primary-header text-center mb-3">
            Create Child Account (s)
          </h3>
          <Fragment>
            {childAccounts.map((child: any, i: number) => (
              <Accordian
                title={
                  isActive && selectedId === i ? `Child ${i + 1}` : getTitle(i)
                }
                isActive={isActive && selectedId === i}
                showDelete={childAccounts.length > 1}
                deleteChild={() => deleteChild(i)}
                toggleAccordian={() => {
                  setIsActive(selectedId === i ? !isActive : true);
                  setSeletedId(i);
                  clearErrors();
                }}
                id={i}
                key={i}
                isValid={validIndexs.findIndex((valid) => valid === i) > -1}
                notValid={inValidIndex === i}
              >
                <FormGroup>
                  <FormFlexWrapper className="two-child-layout mb-0">
                    <div className="child">
                      <Input
                        hideLabel={false}
                        placeholder="First Name"
                        name={`firstName[${i}]`}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value.trim().length > 0;
                          },
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        error={
                          errors.firstName &&
                          errors.firstName[i] &&
                          "Please enter First Name"
                        }
                      />
                    </div>
                    <div className="child">
                      <Input
                        hideLabel={false}
                        label="Last Name"
                        placeholder="Last Name"
                        name={`lastName[${i}]`}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value.trim().length > 0;
                          },
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        error={
                          errors.lastName &&
                          errors.lastName[i] &&
                          "Please enter Last Name"
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="two-child-layout mb-0">
                    <div className="child">
                      <DropdownWrapper>
                        <Controller
                          as={Select}
                          value="value"
                          name={`birthMonth[${i}]`}
                          options={MonthList}
                          placeholder="Birth Month"
                          control={control}
                          rules={{ required: true }}
                          styles={SelectCustomStyles}
                          defaultValue={""}
                          isDisabled={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                        />

                        {errors.birthMonth && errors.birthMonth[i] && (
                          <Error>Please Select Birth Month</Error>
                        )}
                      </DropdownWrapper>
                    </div>
                    <div className="child">
                      <DropdownWrapper>
                        <Controller
                          as={Select}
                          value="value"
                          name={`birthYear[${i}]`}
                          options={yearsList}
                          placeholder="Birth Year"
                          control={control}
                          rules={{ required: true }}
                          styles={SelectCustomStyles}
                          defaultValue={""}
                          isDisabled={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                        />
                        {errors.birthYear && errors.birthYear[i] && (
                          <Error>Please Select Birth Year</Error>
                        )}
                      </DropdownWrapper>
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <DropdownWrapper>
                        <Controller
                          as={Select}
                          value="value"
                          name={`grade[${i}]`}
                          options={gradesList}
                          placeholder="Grade"
                          control={control}
                          rules={{ required: true }}
                          styles={SelectCustomStyles}
                          defaultValue={""}
                          isDisabled={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                        />

                        {errors.grade && errors.grade[i] && (
                          <Error>Please select Grade</Error>
                        )}
                      </DropdownWrapper>
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="two-child-layout mb-0">
                    <div className="child">
                      <Input
                        hideLabel={false}
                        label="City"
                        placeholder="City"
                        name={`city[${i}]`}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value.trim().length > 0;
                          },
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        error={
                          errors.city && errors.city[i] && "Please enter City"
                        }
                      />
                    </div>
                    <div className="child">
                      <DropdownWrapper>
                        <Controller
                          as={Select}
                          value="value"
                          name={`state[${i}]`}
                          options={stateList}
                          placeholder="State"
                          control={control}
                          rules={{ required: true }}
                          styles={SelectCustomStyles}
                          defaultValue={""}
                          isDisabled={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                        />

                        {errors.state && errors.state[i] && (
                          <Error>Please select State</Error>
                        )}
                      </DropdownWrapper>
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Input
                        type="number"
                        hideLabel={false}
                        label="Zip Code"
                        placeholder="Zip Code"
                        name={`zipCode[${i}]`}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return !value || value.trim().length > 0;
                          },
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        error={
                          errors.zipCode &&
                          errors.zipCode[i] &&
                          "Please enter Zip Code"
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Input
                        hideLabel={false}
                        label="Child's Email Address"
                        placeholder="Child's Email Address"
                        name={`email[${i}]`}
                        register={register({
                          required: true,
                          pattern: emailPattern,
                        })}
                        onBlur={() => onEmailBlur(i)}
                        className={
                          !errors.email && emailValidate[i].valid ? "valid" : ""
                        }
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        isValid={
                          !errors.email &&
                          !emailValidate[i].validate &&
                          emailValidate[i].valid
                        }
                        validating={!errors.email && emailValidate[i].validate}
                        error={
                          (errors.email &&
                            errors.email[i] &&
                            errors.email[i].type === "required" &&
                            "Please enter Child's Email Address") ||
                          (errors.email &&
                            errors.email[i] &&
                            errors.email[i].type === "pattern" &&
                            "Please enter a valid Email Address") ||
                          (!errors.email &&
                            emailValidate[i].Eerror &&
                            "Email already exists. Please try with another Email.")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Password
                        label="Password"
                        hideIcon={true}
                        hideLabel={false}
                        placeholder="Password"
                        name={`password[${i}]`}
                        showInfo={true}
                        register={register({
                          required: true,
                          pattern: passwordPattern,
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        onBlur={() => onPasswordBlur(i)}
                        error={
                          (errors.password &&
                            errors.password[i] &&
                            errors.password[i].type === "required" &&
                            "Please enter Password") ||
                          (errors.password &&
                            errors.password[i] &&
                            errors.password[i].type === "pattern" &&
                            "Please enter a Strong Password")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Password
                        label="Confirm Password"
                        hideLabel={false}
                        hideIcon={true}
                        placeholder="Confirm Password"
                        name={`confirmPassword[${i}]`}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value === watch(`password[${i}]`);
                          },
                        })}
                        disable={
                          validIndexs.findIndex((valid) => valid === i) > -1
                        }
                        error={
                          (errors.confirmPassword &&
                            errors.confirmPassword[i] &&
                            errors.confirmPassword[i].type === "required" &&
                            "Please confirm Password") ||
                          (errors.confirmPassword &&
                            errors.confirmPassword[i] &&
                            errors.confirmPassword[i].type === "validate" &&
                            "Passwords did not match")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                </FormGroup>
                <FormGroup>
                  <FormFlexWrapper>
                    <div className="child only-child">
                      <CommonLabel>Who can my child play with?</CommonLabel>
                      {childPlayOptions.map((each: any, index: number) => (
                        <Radio
                          className="radio"
                          name={`childPlayOption[${i}]`}
                          value={each.id}
                          key={each.id + i}
                          checked={true}
                          register={register({
                            required: true,
                          })}
                          disable={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                          id={"play_" + each.id + i}
                          label={each.label}
                        />
                      ))}
                      {errors.childPlayOption && errors.childPlayOption[i] && (
                        <Error>Please select Child Play Option</Error>
                      )}
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper>
                    <div className="child only-child">
                      <CommonLabel>My child may use</CommonLabel>
                      <FlexWrapper>
                        {chatOptions.map((each: any) => (
                          <Radio
                            className="radio mr-3"
                            name={`chatOption[${i}]`}
                            value={each.id}
                            key={each.id + i}
                            checked={true}
                            register={register({
                              required: true,
                            })}
                            disable={
                              validIndexs.findIndex((valid) => valid === i) > -1
                            }
                            id={"chat_" + each.id + i}
                            label={each.label}
                          />
                        ))}
                      </FlexWrapper>
                      {errors.chatOption && errors.chatOption[i] && (
                        <Error>Please select My Child may use</Error>
                      )}
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper>
                    <div className="child only-child">
                      <CommonLabel>Level Preference</CommonLabel>
                      <FlexWrapper>
                        {perferneceOptions.map((each: any) => (
                          <Radio
                            className="radio mr-3"
                            name={`levelPreference[${i}]`}
                            value={each.id}
                            key={each.id + i}
                            checked={true}
                            register={register({
                              required: true,
                            })}
                            disable={
                              validIndexs.findIndex((valid) => valid === i) > -1
                            }
                            id={"level_" + each.id + i}
                            label={each.label}
                          />
                        ))}
                      </FlexWrapper>
                      {errors.levelPreference && errors.levelPreference[i] && (
                        <Error>Please select Level Preference</Error>
                      )}
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <DropdownWrapper>
                        <CommonLabel>
                          Subjects I'd like my child to explore
                        </CommonLabel>
                        <Controller
                          as={Select}
                          value="value"
                          name={`subject[${i}]`}
                          options={subjectOptions}
                          placeholder="Subject(s)"
                          control={control}
                          rules={{ required: true }}
                          styles={SelectCustomStyles}
                          defaultValue={""}
                          isMulti={true}
                          closeMenuOnSelect={false}
                          isDisabled={
                            validIndexs.findIndex((valid) => valid === i) > -1
                          }
                        />
                        {errors.subject && errors.subject[i] && (
                          <Error>Please select atleast one Subject</Error>
                        )}
                      </DropdownWrapper>
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper>
                    <div className="child only-child">
                      <CommonLabel>Subscription Plan</CommonLabel>
                      <SubBox>
                        <FlexWrapper>
                          {subscriptionOptions.map((each: any) => (
                            <Radio
                              className="radio p-0"
                              name={`subscriptionOption[${i}]`}
                              value={each.id}
                              key={each.id + i}
                              checked={true}
                              register={register({
                                required: true,
                              })}
                              id={"plan_" + each.id}
                              label={each.label}
                            />
                          ))}
                        </FlexWrapper>
                      </SubBox>
                    </div>
                  </FormFlexWrapper>
                </FormGroup>
              </Accordian>
            ))}
          </Fragment>
          <button
            type="button"
            className="anchor-tag"
            onClick={() => addChildAccount()}
          >
            + Add New Child
          </button>
          <FlexWrapper className="justify-end">
            <ButtonContainer
              disabled={buttonText === "Linking..."}
              style={{ width: "unset" }}
            >
              <Button
                variant="newsecondary"
                size="large"
                width="195px"
                type="submit"
              >
                {buttonText}
              </Button>
            </ButtonContainer>
          </FlexWrapper>
        </form>
      </Container>
      {showDelete && (
        <DeleteChildDialog
          dialogTitle="Confirm Unlink"
          confirmationText="Are you sure you want to unlink the child's account?"
          confirmationMsg="The child account will be unlinked and you will not be able to access the child's information."
          onClose={() => setShowDetete(false)}
          deleteText={deleteText}
          deleteChild={() => onChildDelete()}
        />
      )}
      {showOverLay && (
        <Overlay title="Child(s) linked successfully">
          Children accounts has been linked to your
          <br /> Parent account successfully.
        </Overlay>
      )}
    </LoginLayout>
  );
}
